<template>
  <div v-if="!servicesLoading && !loadingPromotion">

    <!-- Notificación temporal para errores -->
    <TemporaryNotification v-if="showNotification" :message="notificationMessage" type="error" />

    <div class="searchPromotion">
      <label for="promotionId">¿Quieres copiar una promoción?</label>
      <input style="max-width: 20ch;" type="text" class="form-control" id="promotionId" placeholder="PR00000000" aria-label="promotionId" v-model.trim="modalLoadPromotionId">
      <button type="button" class="btn btn-primary generalPrimaryButton" 
        @click="loadPromotion(modalLoadPromotionId)"
        :disabled="modalLoadPromotionId == ''"
      >
        <span>COPIAR PROMOCIÓN</span>
      </button>
    </div>
    <form @submit.prevent="submit()" autocomplete="off" id="promotionForm" v-on:keypress.enter.prevent="enterKey">
      <div class="row mx-1">
        <div class="col-12">
          <h3 class="generalSubtitle">Datos de la promoción</h3>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="name"><span className='text-danger'>*</span> Nombre</label>
            <input type="text" class="form-control generalInput" id="name"
              v-model.trim.lazy="v$.newPromotion.name.$model" maxlength="40">
            <div v-if="v$.newPromotion.name.$dirty">
              <small class="form-text text-danger" v-if="v$.newPromotion.name.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.newPromotion.name.alphaAccents.$invalid && !v$.newPromotion.name.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="description"><span className='text-danger'>*</span> Descripción</label>
            <input type="text" class="form-control generalInput" id="description"
              v-model.trim="v$.newPromotion.description.$model" maxlength="40">
            <div v-if="v$.newPromotion.description.$dirty">
              <small class="form-text text-danger" v-if="v$.newPromotion.description.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.newPromotion.description.$invalid && !v$.newPromotion.description.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="legalConditions"><span className='text-danger'>*</span> Condiciones legales</label>
            <input type="text" class="form-control generalInput" id="legalConditions"
              v-model.trim="v$.newPromotion.legal_conditions.$model" maxlength="40">
            <div v-if="v$.newPromotion.legal_conditions.$dirty">
              <small class="form-text text-danger" v-if="v$.newPromotion.legal_conditions.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.newPromotion.legal_conditions.$invalid && !v$.newPromotion.legal_conditions.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="description"><span className='text-danger'>*</span> Fecha inicio</label>
            <DatePicker v-model="v$.newPromotion.start_date.$model" mode="date" :model-config="modelConfig" :min-date="new Date()" @update:fromPage="change" @dayclick='checkDate()'>
              <template v-slot="{ togglePopover }">
                <input @click="togglePopover();" class="form-control generalInput bg-white" readonly
                  v-model="v$.newPromotion.start_date.$model" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate_promo" @click="togglePopover();" />
              </template>
            </DatePicker>
            <small class="form-text text-danger" v-if="validDates">La fecha inicio debe ser menor a la fecha final</small>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="description"><span className='text-danger'>*</span> Fecha final</label>
            <DatePicker v-model="v$.newPromotion.end_date.$model" mode="date" :model-config="modelConfig" :min-date="new Date()" @update:fromPage="change" @dayclick='checkDate()'>
              <template v-slot="{ togglePopover }" >
                <input @click="togglePopover();" class="form-control generalInput bg-white" readonly
                  v-model="v$.newPromotion.end_date.$model" />
                <v-icon name="ri-calendar-line" scale="0.9" class="generalSelect__iconDate_promo" @click="togglePopover();" />
              </template>
            </DatePicker>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="tenant"><span className='text-danger'></span> Tenant</label>
            <VueNextSelect class="form-control generalInput" id="tenant" :options="tenantsData" taggable :multiple="true"
              v-model.lazy="v$.newPromotion.tenant.$model" placeholder="" searchable="true" clear-on-close="true" close-on-select>
            </VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="channel"><span className='text-danger'>*</span> Canal</label>
            <VueNextSelect class="form-control generalInput" id="channel" taggable :multiple="true" v-model.lazy="v$.newPromotion.channel.$model"
              :options="channelsData" placeholder="" close-on-select></VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="unitLimit"><span className='text-danger'>*</span> Limite de unidades</label>
            <input type="number" class="form-control generalInput typeNumber" id="unitLimit"
              v-model.trim="v$.newPromotion.units_limit.$model">
            <div v-if="v$.newPromotion.units_limit.$dirty">
              <small class="form-text text-danger" v-if="v$.newPromotion.units_limit.required.$invalid">Campo requerido</small>
              <small class="form-text text-danger"
                v-if="v$.newPromotion.units_limit.$invalid && !v$.newPromotion.units_limit.required.$invalid">El
                formato no es correcto</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-2 pt-4">
          <div class="form-group mb-0 h-100 d-flex align-items-center align-content-middle">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="cumulative"
                v-model.trim="newPromotion.cumulative" />
              <label class="custom-control-label labelCheck" for="cumulative">Acumulable por contrato</label>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-2 pt-4">
          <div class="form-group mb-0 h-100 d-flex align-items-center align-content-middle">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="cumulativeCustumer"
                v-model.trim="newPromotion.cumulativeCustumer" />
              <label class="custom-control-label labelCheck" for="cumulativeCustumer">Acumulable por cliente</label>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-8 col-xl-4 mr-1">
          <div class="form-group">
            <label class="generalLabel" for="priority">Prioridad</label>
            <div class="range d-flex align-items-center justify-content-between">
              <input type="range" min="1" max="10" v-model.trim="newPromotion.priority" @input="changeBarRange($event)" />
              <output id="rangevalue">{{ newPromotion.priority }} </output>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-2 pt-4">
          <div class="form-group mb-0 h-100 d-flex align-items-center align-content-middle">
            <div class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" id="applyToRentServ"
                v-model="newPromotion.applyToRentServ" />
              <label class="custom-control-label labelCheck" for="applyToRentServ">Aplicar sobre BI+IVA</label>
            </div>
          </div>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-12">
          <h3 class="generalSubtitle">Detalle de promoción</h3>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="type"><span className='text-danger'>*</span> Estilo de promocións</label>
            <VueNextSelect class="form-control generalInput" id="type" v-model.lazy="v$.newPromotion.promoType.$model"
              :options="typesDataName" placeholder="" close-on-select></VueNextSelect>
          </div>
        </div>
      </div>
      <div class="row mx-1" v-if="newPromotion.promoType == 'PRODUCTO'">
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="brand">Marca</label>
            <VueNextSelect class="form-control generalInput" id="brand" :options="brandsData" v-model.lazy="v$.newPromotion.brand.$model"
              @click="selectBrand(newPromotion.brand)" close-on-select placeholder="" aria-labelledby="Marca"></VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="model">Modelo</label>
            <VueNextSelect class="form-control generalInput" id="model" :options="modelsData" v-model.lazy="v$.newPromotion.model.$model"
              @click="selectModel(newPromotion.model)" close-on-select placeholder="" aria-labelledby="Modelo"></VueNextSelect>
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="capacity">Capacidad</label>
            <VueNextSelect class="form-control generalInput" id="capacity" :options="capacitiesData"
              v-model.trim="v$.newPromotion.capacity.$model" @click="selectCapacity(newPromotion.capacity)" close-on-select placeholder=""
              aria-labelledby="Capacidad"></VueNextSelect>
            <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
          </div>
        </div>
        <div class="col-12 col-lg-3">
          <div class="form-group">
            <label class="generalLabel" for="color">Color</label>
            <VueNextSelect class="form-control generalInput" id="color" :options="colorsData" v-model.trim="v$.newPromotion.color.$model"
              close-on-select placeholder="" aria-labelledby="Color" @click="selectColor(newPromotion.color)"></VueNextSelect>
            <!-- <v-icon name="hi-solid-chevron-down" scale="1.1" class="generalSelect__icon" /> -->
          </div>
        </div>
        <div class="col-12">
          <button type="button" class="btn btn-primary generalPrimaryButton mx-0 mt-3 mb-4 btn-loading" id="submitButton"
          :disabled="!newPromotion.brand" @click="filter">
          <span v-if="!loading">Aplicar</span>
          <img v-else src="../../../../../assets/loader.svg" height="20" alt="">  
          </button>
        </div>
        <div class="col-12" v-if="Array.isArray(newPromotion.products) && newPromotion.products.length > 0">
          <div style="font-weight: bold; margin-top: 5px; margin-bottom: 5px;">
            <button type="button" aria-label="Close" @click="productRemove" style="color:red; border: none; font-weight: bold;">
              <span aria-hidden="true">X</span>
            </button>
            {{newPromotion.products.join(", ")}}
          </div>
        </div>
      </div>
      <div v-if="newPromotion.promoType == 'CLIENTE'" style="padding-left: 20px;">
        <DropFile @clientList="clientList($event)"/>
        <div v-if="Array.isArray(newPromotion.customers.legal_identifier) && newPromotion.customers.legal_identifier.length > 0" style="font-weight: bold; margin-top: 5px;margin-bottom: 5px;">
          <button type="button" aria-label="Close" @click="clientRemove" style="color:red; border: none; font-weight: bold;">
            <span aria-hidden="true">X</span>
          </button>
          {{newPromotion.customers.legal_identifier.join(", ")}}
        </div>
      </div>
      <div class="row mx-1" v-if="newPromotion.promoType == 'VOUCHER'">
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="legalConditions"><span className='text-danger'>*</span> Cupón promocional</label>
            <input type="text" class="form-control generalInput" id="legalConditions" style="text-transform: uppercase;"
              v-model.trim="v$.newPromotion.vouchers.voucher_code.$model" maxlength="40">
              <div v-if="v$.newPromotion.vouchers.voucher_code.$dirty">
                <small class="form-text text-danger" v-if="v$.newPromotion.vouchers.voucher_code.required.$invalid">Campo requerido</small>
              </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="legalConditions"><span className='text-danger'>*</span> Límite de uso</label>
            <input type="number" class="form-control generalInput typeNumber" id="unitLimit"
              v-model.trim="v$.newPromotion.vouchers.use_limit.$model">
            <div v-if="v$.newPromotion.vouchers.use_limit.$dirty">
              <small class="form-text text-danger" v-if="v$.newPromotion.vouchers.use_limit.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6">
          <DropFile @clientList="clientList($event)"/>
          <div v-if="Array.isArray(newPromotion.customers.legal_identifier) && newPromotion.customers.legal_identifier.length > 0" style="font-weight: bold;">
            <button type="button" aria-label="Close" @click="clientRemove" style="color:red; border: none; font-weight: bold;">
              <span aria-hidden="true">X</span>
            </button>
            {{newPromotion.customers.legal_identifier.join(", ")}}
          </div>
				</div>
      </div>
      <div class="row mx-1" v-if="newPromotion.promoType == 'CRITERIA'">
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="name"><span className='text-danger'>*</span> Nombre</label>
            <input type="text" class="form-control generalInput" id="name"
              v-model.trim.lazy="v$.newPromotion.criteria.name.$model" maxlength="40">
            <div v-if="v$.newPromotion.criteria.name.$dirty">
              <small class="form-text text-danger" v-if="v$.newPromotion.criteria.name.required.$invalid">Campo requerido</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-12">
          <div class="row m-0 criterios">
            <div class="col-12 m-0" style="display: flex;flex-wrap: wrap;">
                <button 
                  v-for="(formula, index) in formulas" :key="formula.name" 
                  class="btn btn-primary generalPrimaryButton" 
                  style="width: 280px;" 
                  :disabled="formula.disabled" 
                  :title="formula.condition"
                  @click.prevent="showModal(index, formula)">
                    {{formula.name}}
                </button>
            </div>
            <div class="col-12 criterios-content">
              <template v-for="(resultado, index) in resultados" :key="index">
                <button 
                  class="btn btn-secundary generalSecondaryButton"
                  :title="resultado.condition"
                  @click.prevent="removeFormula(index, resultado)">
                    {{resultado.name.replace(resultado.parameters,newPromotion.criteria.parameters[resultado.parameters])}}
                </button>
                <select v-if="index < resultados.length-1" class="form-control generalInputl" :id="operadores[index]" @change="changeOperator($event,index)">
                  <option :selected="operadores[index] === '&&'">&&</option>
                  <option :selected="operadores[index] === '||'">||</option>
                </select>
              </template>
            </div>
            <small class="form-text text-danger">Campo requerido</small>
          </div>
        </div>
      </div>
      <div class="row mx-1">
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="discountTypeName"><span className='text-danger'>*</span> Tipo de
              descuento</label>
            <VueNextSelect class="form-control generalInput" id="discountTypeName" :options="discountData"
              v-model.lazy="v$.newPromotion.discountTypeName.$model" placeholder="" close-on-select
              :change="discountTypeNameChange()"></VueNextSelect>
            <div v-if="v$.newPromotion.discountTypeName.$dirty">
              <small class="form-text text-danger" v-if="v$.newPromotion.discountTypeName.required.$invalid">Campo
                requerido</small>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4">
          <div class="form-group">
            <label class="generalLabel" for="executionType"><span className='text-danger'>*</span> Tipo de
              ejecución</label>
            <VueNextSelect class="form-control generalInput" id="executionType" :options="executionData"
              v-model.lazy="v$.newPromotion.executionType.$model" placeholder="" close-on-select></VueNextSelect>
            <div v-if="v$.newPromotion.executionType.$dirty">
              <small class="form-text text-danger" v-if="v$.newPromotion.executionType.required.$invalid">Campo
                requerido</small>
            </div>
          </div>
        </div>
        <template v-if="v$.newPromotion.executionType.$model === 'Todos'">
          <div class="col-12 col-lg-4">
            <div class="form-group">
              <label class="generalLabel" for="feeTotalNumber"><span className='text-danger'>*</span> Cantidad</label>
              <input type="number" class="form-control generalInput typeNumber" id="feeTotalNumber"
                v-model.trim.lazy="v$.newPromotion.feeTotalNumber.$model">
              <div v-if="v$.newPromotion.feeTotalNumber.$dirty">
                <small class="form-text text-danger" v-if="v$.newPromotion.feeTotalNumber.required.$invalid">Campo
                  requerido</small>
                <small class="form-text text-danger"
                  v-if="v$.newPromotion.feeTotalNumber.maxLength.$invalid || v$.newPromotion.feeTotalNumber.minLength.$invalid || v$.newPromotion.feeTotalNumber.maxValue.$invalid || v$.newPromotion.feeTotalNumber.minValue.$invalid">El
                  formato no es correcto</small>
              </div>
            </div>
          </div>
        </template>
        <template v-else-if="v$.newPromotion.executionType.$model === 'Selección'">
          <div class="col-12 px-0">
            <div class="form-group">
              <div class="d-flex align-items-start justify-content-start flex-wrap">
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee1'"><span className='text-danger'>*</span>Cuota 1</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee1'"
                    v-model.trim.lazy="v$.newPromotion.fee1.value.$model">
                  <div v-if="v$.newPromotion.fee1.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee1.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee1.value.maxLength.$invalid || v$.newPromotion.fee1.value.minLength.$invalid || v$.newPromotion.fee1.value.maxValue.$invalid || v$.newPromotion.fee1.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee2'"><span className='text-danger'>*</span>Cuota 2</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee2'"
                    v-model.trim.lazy="v$.newPromotion.fee2.value.$model">
                  <div v-if="v$.newPromotion.fee2.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee2.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee2.value.maxLength.$invalid || v$.newPromotion.fee2.value.minLength.$invalid || v$.newPromotion.fee2.value.maxValue.$invalid || v$.newPromotion.fee2.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee3'"><span className='text-danger'>*</span>Cuota 3</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee3'"
                    v-model.trim.lazy="v$.newPromotion.fee3.value.$model">
                  <div v-if="v$.newPromotion.fee3.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee3.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee3.value.maxLength.$invalid || v$.newPromotion.fee3.value.minLength.$invalid || v$.newPromotion.fee3.value.maxValue.$invalid || v$.newPromotion.fee3.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee4'"><span className='text-danger'>*</span>Cuota 4</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee4'"
                    v-model.trim.lazy="v$.newPromotion.fee4.value.$model">
                  <div v-if="v$.newPromotion.fee4.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee4.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee4.value.maxLength.$invalid || v$.newPromotion.fee4.value.minLength.$invalid || v$.newPromotion.fee4.value.maxValue.$invalid || v$.newPromotion.fee4.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee5'"><span className='text-danger'>*</span>Cuota 5</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee5'"
                    v-model.trim.lazy="v$.newPromotion.fee5.value.$model">
                  <div v-if="v$.newPromotion.fee5.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee5.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee5.value.maxLength.$invalid || v$.newPromotion.fee5.value.minLength.$invalid || v$.newPromotion.fee5.value.maxValue.$invalid || v$.newPromotion.fee5.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee6'"><span className='text-danger'>*</span>Cuota 6</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee6'"
                    v-model.trim.lazy="v$.newPromotion.fee6.value.$model">
                  <div v-if="v$.newPromotion.fee6.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee6.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee6.value.maxLength.$invalid || v$.newPromotion.fee6.value.minLength.$invalid || v$.newPromotion.fee6.value.maxValue.$invalid || v$.newPromotion.fee6.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee7'"><span className='text-danger'>*</span>Cuota 7</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee7'"
                    v-model.trim.lazy="v$.newPromotion.fee7.value.$model">
                  <div v-if="v$.newPromotion.fee7.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee7.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee7.value.maxLength.$invalid || v$.newPromotion.fee7.value.minLength.$invalid || v$.newPromotion.fee7.value.maxValue.$invalid || v$.newPromotion.fee7.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee8'"><span className='text-danger'>*</span>Cuota 8</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee8'"
                    v-model.trim.lazy="v$.newPromotion.fee8.value.$model">
                  <div v-if="v$.newPromotion.fee8.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee8.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee8.value.maxLength.$invalid || v$.newPromotion.fee8.value.minLength.$invalid || v$.newPromotion.fee8.value.maxValue.$invalid || v$.newPromotion.fee8.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee9'"><span className='text-danger'>*</span>Cuota 9</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee9'"
                    v-model.trim.lazy="v$.newPromotion.fee9.value.$model">
                  <div v-if="v$.newPromotion.fee9.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee9.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee9.value.maxLength.$invalid || v$.newPromotion.fee9.value.minLength.$invalid || v$.newPromotion.fee9.value.maxValue.$invalid || v$.newPromotion.fee9.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee10'"><span className='text-danger'>*</span>Cuota 10</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee10'"
                    v-model.trim.lazy="v$.newPromotion.fee10.value.$model">
                  <div v-if="v$.newPromotion.fee10.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee10.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee10.value.maxLength.$invalid || v$.newPromotion.fee10.value.minLength.$invalid || v$.newPromotion.fee10.value.maxValue.$invalid || v$.newPromotion.fee10.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee11'"><span className='text-danger'>*</span>Cuota 11</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee11'"
                    v-model.trim.lazy="v$.newPromotion.fee11.value.$model">
                  <div v-if="v$.newPromotion.fee11.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee11.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee11.value.maxLength.$invalid || v$.newPromotion.fee11.value.minLength.$invalid || v$.newPromotion.fee11.value.maxValue.$invalid || v$.newPromotion.fee11.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee12'"><span className='text-danger'>*</span>Cuota 12</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee12'"
                    v-model.trim.lazy="v$.newPromotion.fee12.value.$model">
                  <div v-if="v$.newPromotion.fee12.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee12.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee12.value.maxLength.$invalid || v$.newPromotion.fee12.value.minLength.$invalid || v$.newPromotion.fee12.value.maxValue.$invalid || v$.newPromotion.fee12.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee13'"><span className='text-danger'>*</span>Cuota 13</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee13'"
                    v-model.trim.lazy="v$.newPromotion.fee13.value.$model">
                  <div v-if="v$.newPromotion.fee13.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee13.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee13.value.maxLength.$invalid || v$.newPromotion.fee13.value.minLength.$invalid || v$.newPromotion.fee13.value.maxValue.$invalid || v$.newPromotion.fee13.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee14'"><span className='text-danger'>*</span>Cuota 14</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee14'"
                    v-model.trim.lazy="v$.newPromotion.fee14.value.$model">
                  <div v-if="v$.newPromotion.fee14.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee14.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee14.value.maxLength.$invalid || v$.newPromotion.fee14.value.minLength.$invalid || v$.newPromotion.fee14.value.maxValue.$invalid || v$.newPromotion.fee14.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee15'"><span className='text-danger'>*</span>Cuota 15</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee15'"
                    v-model.trim.lazy="v$.newPromotion.fee15.value.$model">
                  <div v-if="v$.newPromotion.fee15.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee15.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee15.value.maxLength.$invalid || v$.newPromotion.fee15.value.minLength.$invalid || v$.newPromotion.fee15.value.maxValue.$invalid || v$.newPromotion.fee15.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee16'"><span className='text-danger'>*</span>Cuota 16</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee16'"
                    v-model.trim.lazy="v$.newPromotion.fee16.value.$model">
                  <div v-if="v$.newPromotion.fee16.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee16.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee16.value.maxLength.$invalid || v$.newPromotion.fee16.value.minLength.$invalid || v$.newPromotion.fee16.value.maxValue.$invalid || v$.newPromotion.fee16.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee17'"><span className='text-danger'>*</span>Cuota 17</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee17'"
                    v-model.trim.lazy="v$.newPromotion.fee17.value.$model">
                  <div v-if="v$.newPromotion.fee17.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee17.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee17.value.maxLength.$invalid || v$.newPromotion.fee17.value.minLength.$invalid || v$.newPromotion.fee17.value.maxValue.$invalid || v$.newPromotion.fee17.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee18'"><span className='text-danger'>*</span>Cuota 18</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee18'"
                    v-model.trim.lazy="v$.newPromotion.fee18.value.$model">
                  <div v-if="v$.newPromotion.fee18.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee18.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee18.value.maxLength.$invalid || v$.newPromotion.fee18.value.minLength.$invalid || v$.newPromotion.fee18.value.maxValue.$invalid || v$.newPromotion.fee18.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee19'"><span className='text-danger'>*</span>Cuota 19</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee19'"
                    v-model.trim.lazy="v$.newPromotion.fee19.value.$model">
                  <div v-if="v$.newPromotion.fee19.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee19.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee19.value.maxLength.$invalid || v$.newPromotion.fee19.value.minLength.$invalid || v$.newPromotion.fee19.value.maxValue.$invalid || v$.newPromotion.fee19.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee20'"><span className='text-danger'>*</span>Cuota 20</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee20'"
                    v-model.trim.lazy="v$.newPromotion.fee20.value.$model">
                  <div v-if="v$.newPromotion.fee20.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee20.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee20.value.maxLength.$invalid || v$.newPromotion.fee20.value.minLength.$invalid || v$.newPromotion.fee20.value.maxValue.$invalid || v$.newPromotion.fee20.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee21'"><span className='text-danger'>*</span>Cuota 21</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee21'"
                    v-model.trim.lazy="v$.newPromotion.fee21.value.$model">
                  <div v-if="v$.newPromotion.fee21.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee21.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee21.value.maxLength.$invalid || v$.newPromotion.fee21.value.minLength.$invalid || v$.newPromotion.fee21.value.maxValue.$invalid || v$.newPromotion.fee21.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee22'"><span className='text-danger'>*</span>Cuota 22</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee22'"
                    v-model.trim.lazy="v$.newPromotion.fee22.value.$model">
                  <div v-if="v$.newPromotion.fee22.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee22.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee22.value.maxLength.$invalid || v$.newPromotion.fee22.value.minLength.$invalid || v$.newPromotion.fee22.value.maxValue.$invalid || v$.newPromotion.fee22.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee23'"><span className='text-danger'>*</span>Cuota 23</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee23'"
                    v-model.trim.lazy="v$.newPromotion.fee23.value.$model">
                  <div v-if="v$.newPromotion.fee23.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee23.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee23.value.maxLength.$invalid || v$.newPromotion.fee23.value.minLength.$invalid || v$.newPromotion.fee23.value.maxValue.$invalid || v$.newPromotion.fee23.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee24'"><span className='text-danger'>*</span>Cuota 24</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee24'"
                    v-model.trim.lazy="v$.newPromotion.fee24.value.$model">
                  <div v-if="v$.newPromotion.fee24.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee24.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                      v-if="v$.newPromotion.fee24.value.maxLength.$invalid || v$.newPromotion.fee24.value.minLength.$invalid || v$.newPromotion.fee24.value.maxValue.$invalid || v$.newPromotion.fee24.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee25'"><span className='text-danger'>*</span>Cuota 25</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee25'"
                         v-model.trim.lazy="v$.newPromotion.fee25.value.$model">
                  <div v-if="v$.newPromotion.fee25.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee25.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee25.value.maxLength.$invalid || v$.newPromotion.fee25.value.minLength.$invalid || v$.newPromotion.fee25.value.maxValue.$invalid || v$.newPromotion.fee25.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee26'"><span className='text-danger'>*</span>Cuota 26</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee26'"
                         v-model.trim.lazy="v$.newPromotion.fee26.value.$model">
                  <div v-if="v$.newPromotion.fee26.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee26.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee26.value.maxLength.$invalid || v$.newPromotion.fee26.value.minLength.$invalid || v$.newPromotion.fee26.value.maxValue.$invalid || v$.newPromotion.fee26.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee27'"><span className='text-danger'>*</span>Cuota 27</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee27'"
                         v-model.trim.lazy="v$.newPromotion.fee27.value.$model">
                  <div v-if="v$.newPromotion.fee27.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee27.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee27.value.maxLength.$invalid || v$.newPromotion.fee27.value.minLength.$invalid || v$.newPromotion.fee27.value.maxValue.$invalid || v$.newPromotion.fee27.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee28'"><span className='text-danger'>*</span>Cuota 28</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee28'"
                         v-model.trim.lazy="v$.newPromotion.fee28.value.$model">
                  <div v-if="v$.newPromotion.fee28.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee28.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee28.value.maxLength.$invalid || v$.newPromotion.fee28.value.minLength.$invalid || v$.newPromotion.fee28.value.maxValue.$invalid || v$.newPromotion.fee28.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee29'"><span className='text-danger'>*</span>Cuota 29</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee29'"
                         v-model.trim.lazy="v$.newPromotion.fee29.value.$model">
                  <div v-if="v$.newPromotion.fee29.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee29.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee29.value.maxLength.$invalid || v$.newPromotion.fee29.value.minLength.$invalid || v$.newPromotion.fee29.value.maxValue.$invalid || v$.newPromotion.fee29.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee30'"><span className='text-danger'>*</span>Cuota 30</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee30'"
                         v-model.trim.lazy="v$.newPromotion.fee30.value.$model">
                  <div v-if="v$.newPromotion.fee30.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee30.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee30.value.maxLength.$invalid || v$.newPromotion.fee30.value.minLength.$invalid || v$.newPromotion.fee30.value.maxValue.$invalid || v$.newPromotion.fee30.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee31'"><span className='text-danger'>*</span>Cuota 31</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee31'"
                         v-model.trim.lazy="v$.newPromotion.fee31.value.$model">
                  <div v-if="v$.newPromotion.fee31.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee31.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee31.value.maxLength.$invalid || v$.newPromotion.fee31.value.minLength.$invalid || v$.newPromotion.fee31.value.maxValue.$invalid || v$.newPromotion.fee31.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee32'"><span className='text-danger'>*</span>Cuota 32</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee32'"
                         v-model.trim.lazy="v$.newPromotion.fee32.value.$model">
                  <div v-if="v$.newPromotion.fee32.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee32.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee32.value.maxLength.$invalid || v$.newPromotion.fee32.value.minLength.$invalid || v$.newPromotion.fee32.value.maxValue.$invalid || v$.newPromotion.fee32.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee33'"><span className='text-danger'>*</span>Cuota 33</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee33'"
                         v-model.trim.lazy="v$.newPromotion.fee33.value.$model">
                  <div v-if="v$.newPromotion.fee33.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee33.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee33.value.maxLength.$invalid || v$.newPromotion.fee33.value.minLength.$invalid || v$.newPromotion.fee33.value.maxValue.$invalid || v$.newPromotion.fee33.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee34'"><span className='text-danger'>*</span>Cuota 34</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee34'"
                         v-model.trim.lazy="v$.newPromotion.fee34.value.$model">
                  <div v-if="v$.newPromotion.fee34.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee34.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee34.value.maxLength.$invalid || v$.newPromotion.fee34.value.minLength.$invalid || v$.newPromotion.fee34.value.maxValue.$invalid || v$.newPromotion.fee34.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee35'"><span className='text-danger'>*</span>Cuota 35</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee35'"
                         v-model.trim.lazy="v$.newPromotion.fee35.value.$model">
                  <div v-if="v$.newPromotion.fee35.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee35.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee35.value.maxLength.$invalid || v$.newPromotion.fee35.value.minLength.$invalid || v$.newPromotion.fee35.value.maxValue.$invalid || v$.newPromotion.fee35.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
                <div class="mt-3 col-2">
                  <label class="generalLabel" :for="'fee36'"><span className='text-danger'>*</span>Cuota 36</label>
                  <input type="number" class="form-control generalInput typeNumber" :id="'fee36'"
                         v-model.trim.lazy="v$.newPromotion.fee36.value.$model">
                  <div v-if="v$.newPromotion.fee36.value.$dirty">
                    <small class="form-text text-danger" v-if="v$.newPromotion.fee36.value.required.$invalid">Campo
                      requerido</small>
                    <small class="form-text text-danger"
                           v-if="v$.newPromotion.fee36.value.maxLength.$invalid || v$.newPromotion.fee36.value.minLength.$invalid || v$.newPromotion.fee36.value.maxValue.$invalid || v$.newPromotion.fee36.value.minValue.$invalid">El
                      formato no es correcto</small>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="row mt-5 mx-1">
        <div class="col-12">
          <button class="btn btn-primary float-right generalPrimaryButton btn-loading" id="submitButton"
            v-bind:class="[(v$.$invalid) || loadingSubmit || validDates ? 'disabled' : '' ]" :disabled="(v$.$invalid) || loadingSubmit || validDates">
            <span v-if="!loadingSubmit">CONTINUAR</span>
            <img v-else src="../../../../../assets/loader.svg" height="20" alt="">  
          </button>
        </div>
      </div>
    </form>
  </div>
  <div class="col-12 text-center" v-else>
    <img class="mt-5" src="../../../../../assets/loaderPrimary.svg" height="60" alt="">
  </div>
  <ModalCriteriaValor v-if="showModalCriteria" :id="'showModalCriteria'" :formulaModal="formulaModal" :modalTitle="'INTRODUCE VALOR DEL CRITERIO'" :class="'modal-xs'" @guardarFormula="addFormula($event)" @closeModal="showModalCriteria = false" />
  <ModalLoadPromotion v-if="showModalLoadPromotion" :id="'showModalLoadPromotion'" :message="modalLoadPromotionMessage" :modalTitle="'CARGA PROMOCIÓN'" :class="'modal-xs'" @closeModal="showModalLoadPromotion = false; modalLoadPromotionMessage = '';" />
</template>

<script>
const alphaAccents = (value) => {
  if (value != '') {
    if (/[a-zA-ZÀ-ÿ\u00f1\u00d1]{2,3}/gi.test(value))
      return true
    else return false
  } else {
    return true
  }
}
import TemporaryNotification from '../../../Shared/TemporaryNotification.vue';
import { DatePicker } from 'v-calendar';
import VueNextSelect from 'vue-next-select'
import useVuelidate from '@vuelidate/core';
import DropFile from '../templates/DropFile.vue';
import { required, maxLength, minLength, maxValue, minValue, requiredIf } from '@vuelidate/validators'
import axios from "axios";
import ModalCriteriaValor from './ModalCriteriaValor.vue';
import ModalLoadPromotion from './ModalLoadPromotion.vue';
import { Modal as ModalBootstrap } from "bootstrap";
import { useRoute } from 'vue-router';


export default {
  name: 'promotionData',
  setup() {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      promotionIdURL: '',
      services: {
        tenants: false,
        promotionType: false,
        rules: false,
      },
      servicesLoading: true,
      loadingPromotion: false,
      loading: false,
      loadingSubmit: false,
      maxLength: 3,
      maxValue: 100,
      minValue: 0,
      validDates: false,
      showModalCriteria: false,
      showModalLoadPromotion: false,
      modalLoadPromotionId: '',
      modalLoadPromotionMessage: '',
      formulaModal: null,
      indexFormula: null,
      formulas: [],
      resultados: [],
      operadores: [],
      newPromotion: {
        name: this.$store.state.newPromotionData.name,
        tenant: this.$store.state.newPromotionData.tenant || [],
        channel: this.$store.state.newPromotionData.channel,
        description: this.$store.state.newPromotionData.description,
        legal_conditions: this.$store.state.newPromotionData.legal_conditions,
        promoType: this.$store.state.recoveryData.promoType,
        units_limit: this.$store.state.newPromotionData.units_limit,
        start_date: this.$store.state.newPromotionData.start_date,
        end_date: this.$store.state.newPromotionData.end_date,
        priority: this.$store.state.newPromotionData.priority,
        autoAssignment: this.$store.state.newPromotionData.autoAssignment,
        cumulative: this.$store.state.newPromotionData.cumulative,
        cumulativeCustumer: this.$store.state.newPromotionData.cumulativeCustumer,
        applyToRentServ: this.$store.state.newPromotionData.applyToRentServ,
        version: this.$store.state.newPromotionData.version,
        discountTypeName: this.$store.state.recoveryData.discountTypeName,
        executionType: this.$store.state.recoveryData.executionType || '',
        feeTotalNumber: this.$store.state.recoveryData.feeTotalNumber,
        criteria: {
          name: '',
          condition: '',
          parameters: null
        },
        products: [],
        customers: this.$store.state.newPromotionData.customers,
        vouchers: {
          voucher_code: this.$store.state.newPromotionData.vouchers.voucher_code,
          use_limit: this.$store.state.newPromotionData.vouchers.use_limit
        },
        feeDiscounts: [],
        fee1:
        {
          feeNumber: 1,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee1 ? this.$store.state.recoveryData.fee1.value : '0'
        },
        fee2:
        {
          feeNumber: 2,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee2 ? this.$store.state.recoveryData.fee2.value : '0'
        },
        fee3:
        {
          feeNumber: 3,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee3 ? this.$store.state.recoveryData.fee3.value : '0'
        },
        fee4:
        {
          feeNumber: 4,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee4 ? this.$store.state.recoveryData.fee4.value : '0'
        },
        fee5:
        {
          feeNumber: 5,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee5 ? this.$store.state.recoveryData.fee5.value : '0'
        },
        fee6:
        {
          feeNumber: 6,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee6 ? this.$store.state.recoveryData.fee6.value : '0'
        },
        fee7:
        {
          feeNumber: 7,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee7 ? this.$store.state.recoveryData.fee7.value : '0'
        },
        fee8:
        {
          feeNumber: 8,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee8 ? this.$store.state.recoveryData.fee8.value : '0'
        },
        fee9:
        {
          feeNumber: 9,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee9 ? this.$store.state.recoveryData.fee9.value : '0'
        },
        fee10:
        {
          feeNumber: 10,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee10 ? this.$store.state.recoveryData.fee10.value : '0'
        },
        fee11:
        {
          feeNumber: 11,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee11 ? this.$store.state.recoveryData.fee11.value : '0'
        },
        fee12:
        {
          feeNumber: 12,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee12 ? this.$store.state.recoveryData.fee12.value : '0'
        },
        fee13:
        {
          feeNumber: 13,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee13 ? this.$store.state.recoveryData.fee13.value : '0'
        },
        fee14:
        {
          feeNumber: 14,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee14 ? this.$store.state.recoveryData.fee14.value : '0'
        },
        fee15:
        {
          feeNumber: 15,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee15 ? this.$store.state.recoveryData.fee15.value : '0'
        },
        fee16:
        {
          feeNumber: 16,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee16 ? this.$store.state.recoveryData.fee16.value : '0'
        },
        fee17:
        {
          feeNumber: 17,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee17 ? this.$store.state.recoveryData.fee17.value : '0'
        },
        fee18:
        {
          feeNumber: 18,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee18 ? this.$store.state.recoveryData.fee18.value : '0'
        },
        fee19:
        {
          feeNumber: 19,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee19 ? this.$store.state.recoveryData.fee19.value : '0'
        },
        fee20:
        {
          feeNumber: 20,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee20 ? this.$store.state.recoveryData.fee20.value : '0'
        },
        fee21:
        {
          feeNumber: 21,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee21 ? this.$store.state.recoveryData.fee21.value : '0'
        },
        fee22:
        {
          feeNumber: 22,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee22 ? this.$store.state.recoveryData.fee22.value : '0'
        },
        fee23:
        {
          feeNumber: 23,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee23 ? this.$store.state.recoveryData.fee23.value : '0'
        },
        fee24:
        {
          feeNumber: 24,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee24 ? this.$store.state.recoveryData.fee24.value : '0'
        },
        fee25:
        {
          feeNumber: 25,
          discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
          value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee25 ? this.$store.state.recoveryData.fee25.value : '0'
        },
        fee26:
            {
              feeNumber: 26,
              discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
              value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee26 ? this.$store.state.recoveryData.fee26.value : '0'
            },
        fee27:
            {
              feeNumber: 27,
              discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
              value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee27 ? this.$store.state.recoveryData.fee27.value : '0'
            },
        fee28:
            {
              feeNumber: 28,
              discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
              value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee28 ? this.$store.state.recoveryData.fee28.value : '0'
            },
        fee29:
            {
              feeNumber: 29,
              discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
              value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee29 ? this.$store.state.recoveryData.fee29.value : '0'
            },
        fee30:
            {
              feeNumber: 30,
              discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
              value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee30 ? this.$store.state.recoveryData.fee30.value : '0'
            },
        fee31:
            {
              feeNumber: 31,
              discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
              value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee31 ? this.$store.state.recoveryData.fee31.value : '0'
            },
        fee32:
            {
              feeNumber: 32,
              discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
              value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee32 ? this.$store.state.recoveryData.fee32.value : '0'
            },
        fee33:
            {
              feeNumber: 33,
              discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
              value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee33 ? this.$store.state.recoveryData.fee33.value : '0'
            },
        fee34:
            {
              feeNumber: 34,
              discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
              value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee34 ? this.$store.state.recoveryData.fee34.value : '0'
            },
        fee35:
            {
              feeNumber: 35,
              discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
              value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee35 ? this.$store.state.recoveryData.fee35.value : '0'
            },
        fee36:
            {
              feeNumber: 36,
              discountType: this.$store.state.recoveryData.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
              value: this.$store.state.recoveryData.executionType == 'Selección' && this.$store.state.recoveryData.fee36 ? this.$store.state.recoveryData.fee36.value : '0'
            },
        brand: '',
        model: '',
        capacity: '',
        color: '',
      },
      discountData: ['Porcentaje', 'Absoluto'],
      executionData: ['Selección', 'Todos'],
      promotionTypes: {},
      typesDataName: [],
      typesDataId: [],
      channelsData: ["WEB", "POS", "PHYS"],
      tenantsData: [],
      modelConfig: {
        type: 'string',
        mask: 'DD/MM/YYYY',
      },
      brandsData: [],
      modelsData: [],
      capacitiesData: [],
      colorsData: [],
      startDate: '',
      endDate: '',
      notificationMessage: '',
      showNotification: false,
    }
  },
  components: {
    DatePicker,
    VueNextSelect,
    DropFile,
    ModalCriteriaValor,
    ModalLoadPromotion,
    TemporaryNotification,
  },
  watch: {
    'v$.newPromotion.promoType.$model': function (newVal) {
      if(newVal !== '') {
        if(newVal != "CRITERIA") {
          this.newPromotion.criteria = {
            name: '',
            condition: '',
            parameters: null
          }

          this.resultados = [];
          this.operadores = [];
          this.formulaModal = null;
          this.indexFormula = null;

          this.formulas.forEach((element) => {
            element.disabled = false;
          });
        }
        if(newVal != "CLIENTE" && newVal != "VOUCHER") {
          this.newPromotion.customers.legal_identifier = [];
        }
        if(newVal != "VOUCHER") {
          this.newPromotion.vouchers.voucher_code = "";
          this.newPromotion.vouchers.use_limit = "";
        }
        if(newVal != "PRODUCTO") {
          this.newPromotion.products = [];
        }
      }
    },
    'v$.newPromotion.executionType.$model': function (newVal) {
      if(newVal === 'Selección'){
        this.newPromotion.feeTotalNumber = '';
      }
    },
    'services': {
      handler: function (newVal) {
        let allTrue = true;
        for (let key in newVal) {
          if (Object.prototype.hasOwnProperty.call(newVal, key) && newVal[key] !== true) {
            allTrue = false;
            break;
          }
        }
        if (allTrue) {
          if (this.promotionIdURL !== '') {
            this.loadPromotion(this.promotionIdURL);
          } else {
            this.updateCriteria(
              {
                name: this.$store.state.newPromotionData.criteria.name,
                condition: this.$store.state.newPromotionData.criteria.condition,
                parameters: this.$store.state.newPromotionData.criteria.parameters
              }
            )
          }
          this.servicesLoading = false;
        }
      },
      deep: true
    }
  },
  validations() {
    return {
      newPromotion: {
        name: {
          required,
          alphaAccents,
        },
        description: {
          required,
        },
        legal_conditions: {
          required,
        },
        tenant: {
          required: false,
        },
        channel: {
          required,
        },
        units_limit: {
          required,
        },
        start_date: {
          required
        },
        end_date: {
          required
        },
        discountTypeName: {
          required
        },
        executionType: {
          required
        },
        promoType: {
          required
        },
        brand: {
          required: requiredIf(function () {
            if (this.newPromotion.promoType == "PRODUCTO") {
              return true;
            } else {
              return false;
            }
          }),
        },
        customers: {
          legal_identifier: {
            required: requiredIf(function () {
              if (this.newPromotion.promoType == "CLIENTE") {
                return true;
              } else {
                return false;
              }
            }),
            minLength: minLength(1),
          }
        },
        criteria: {
          name: {
            required: requiredIf(function () {
              if (this.newPromotion.promoType == "CRITERIA") {
                return true;
              } else {
                return false;
              }
            }),
          },
          condition: {
            required: requiredIf(function () {
              if (this.newPromotion.promoType == "CRITERIA") {
                return true;
              } else {
                return false;
              }
            }),
          }
        },
        model: {
        },
        capacity: {
        },
        color: {
        },
        products: {
          required: requiredIf(function () {
            if (this.newPromotion.promoType == "PRODUCTO") {
              return true;
            } else {
              return false;
            }
          }),
          minLength: minLength(1),
        },
        vouchers: {
          voucher_code: {
            required: requiredIf(function () {
              if (this.newPromotion.promoType == "VOUCHER") {
                return true;
              } else {
                return false;
              }
            }),
          },
          use_limit: {
            required: requiredIf(function () {
              if (this.newPromotion.promoType == "VOUCHER") {
                return true;
              } else {
                return false;
              }
            }),
          }
        },
        feeTotalNumber: {
          required: requiredIf(function () {
            if (this.newPromotion.executionType == "Todos") {
              return true;
            } else {
              return false;
            }
          }),
          maxLength: maxLength(this.maxLength),
          minLength: minLength(1),
          maxValue: maxValue(this.maxValue),
          minValue: minValue(this.minValue)
        },
        fee1: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee2: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee3: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee4: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee5: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee6: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee7: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee8: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee9: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee10: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee11: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee12: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee13: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee14: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee15: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee16: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee17: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee18: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee19: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee20: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee21: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee22: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee23: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee24: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee25: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee26: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee27: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee28: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee29: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee30: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee31: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee32: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee33: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee34: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee35: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
        fee36: {
          value: {
            required: requiredIf(function () {
              if (this.newPromotion.executionType == "Selección") {
                return true;
              } else {
                return false;
              }
            }),
            maxLength: maxLength(this.maxLength),
            minLength: minLength(1),
            maxValue: maxValue(this.maxValue),
            minValue: minValue(this.minValue)
          }
        },
      },
    }
  },
  created() {
    const route = useRoute();
    const idPromotion = route.query.idPromotion;
    if(idPromotion) {
      const currentPath = this.$route.path;
      this.$router.replace(currentPath);
      this.promotionIdURL = idPromotion;
    }
    this.loadTenantData();
    this.loadBrandsData();
    this.loadPromoType();
    this.checkDate();
    this.loadRules();
  },
  update(){
    this.checkDate();
  },
  methods: {
    checkDate() {
      let startDate = this.$dateFrontToBack(this.newPromotion.start_date);
      let endDate = this.$dateFrontToBack(this.newPromotion.end_date);
      startDate = new Date(startDate);
      endDate = new Date(endDate);
      if (startDate >= endDate) {
        this.validDates = true;
      }else{
        this.validDates = false;
      }
    },
    clientList(list){
      this.newPromotion.customers.legal_identifier = list;
    },
    clientRemove(){
      this.newPromotion.customers.legal_identifier = [];
    },
    productRemove(){
      this.newPromotion.products = [];
    },
    submit() {
      if (this.v$.$invalid || this.validDates) {
        this.notificationMessage = 'Por favor, revisa los campos obligatorios y asegúrate de que los datos son correctos.';
        this.showNotification = true;
        setTimeout(() => {
          this.showNotification = false;
        }, 3000); // La notificación desaparecerá después de 3 segundos.
        return; // Detener el envío si hay errores.
      }
      this.loadingSubmit = true; 
      let fee1 = {
        feeNumber: this.newPromotion.fee1.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee1.value.toString(),
      };
      let fee2 = {
        feeNumber: this.newPromotion.fee2.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee2.value.toString(),
      };
      let fee3 = {
        feeNumber: this.newPromotion.fee3.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee3.value.toString(),
      };
      let fee4 = {
        feeNumber: this.newPromotion.fee4.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee4.value.toString(),
      };
      let fee5 = {
        feeNumber: this.newPromotion.fee5.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee5.value.toString(),
      };
      let fee6 = {
        feeNumber: this.newPromotion.fee6.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee6.value.toString(),
      };
      let fee7 = {
        feeNumber: this.newPromotion.fee7.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee7.value.toString(),
      };
      let fee8 = {
        feeNumber: this.newPromotion.fee8.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee8.value.toString(),
      };
      let fee9 = {
        feeNumber: this.newPromotion.fee9.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee9.value.toString(),
      };
      let fee10 = {
        feeNumber: this.newPromotion.fee10.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee10.value.toString(),
      };
      let fee11 = {
        feeNumber: this.newPromotion.fee11.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee11.value.toString(),
      };
      let fee12 = {
        feeNumber: this.newPromotion.fee12.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee12.value.toString(),
      };
      let fee13 = {
        feeNumber: this.newPromotion.fee13.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee13.value.toString(),
      };
      let fee14 = {
        feeNumber: this.newPromotion.fee14.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee14.value.toString(),
      };
      let fee15 = {
        feeNumber: this.newPromotion.fee15.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee15.value.toString(),
      };
      let fee16 = {
        feeNumber: this.newPromotion.fee16.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee16.value.toString(),
      };
      let fee17 = {
        feeNumber: this.newPromotion.fee17.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee17.value.toString(),
      };
      let fee18 = {
        feeNumber: this.newPromotion.fee18.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee18.value.toString(),
      };
      let fee19 = {
        feeNumber: this.newPromotion.fee19.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee19.value.toString(),
      };
      let fee20 = {
        feeNumber: this.newPromotion.fee20.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee20.value.toString(),
      };
      let fee21 = {
        feeNumber: this.newPromotion.fee21.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee21.value.toString(),
      };
      let fee22 = {
        feeNumber: this.newPromotion.fee22.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee22.value.toString(),
      };
      let fee23 = {
        feeNumber: this.newPromotion.fee23.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee23.value.toString(),
      };
      let fee24 = {
        feeNumber: this.newPromotion.fee24.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee24.value.toString(),
      };
      let fee25 = {
        feeNumber: this.newPromotion.fee25.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee25.value.toString(),
      };
      let fee26 = {
        feeNumber: this.newPromotion.fee26.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee26.value.toString(),
      };
      let fee27 = {
        feeNumber: this.newPromotion.fee27.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee27.value.toString(),
      };
      let fee28 = {
        feeNumber: this.newPromotion.fee28.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee28.value.toString(),
      };
      let fee29 = {
        feeNumber: this.newPromotion.fee29.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee29.value.toString(),
      };
      let fee30 = {
        feeNumber: this.newPromotion.fee30.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee30.value.toString(),
      };
      let fee31 = {
        feeNumber: this.newPromotion.fee31.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee31.value.toString(),
      };
      let fee32 = {
        feeNumber: this.newPromotion.fee32.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee32.value.toString(),
      };
      let fee33 = {
        feeNumber: this.newPromotion.fee33.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee33.value.toString(),
      };
      let fee34 = {
        feeNumber: this.newPromotion.fee34.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee34.value.toString(),
      };
      let fee35 = {
        feeNumber: this.newPromotion.fee35.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee35.value.toString(),
      };
      let fee36 = {
        feeNumber: this.newPromotion.fee36.feeNumber.toString(),
        discountType: this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE",
        value: this.newPromotion.fee36.value.toString(),
      };
      let bodyToSave = '';
      let recoveryData = '';
      recoveryData = {
        fee1,
        fee2,
        fee3,
        fee4,
        fee5,
        fee6,
        fee7,
        fee8,
        fee9,
        fee10,
        fee11,
        fee12,
        fee13,
        fee14,
        fee15,
        fee16,
        fee17,
        fee18,
        fee19,
        fee20,
        fee21,
        fee22,
        fee23,
        fee24,
        fee25,
        fee26,
        fee27,
        fee28,
        fee29,
        fee30,
        fee31,
        fee32,
        fee33,
        fee34,
        fee35,
        fee36,

        feeTotalNumber: this.newPromotion.feeTotalNumber,
        promoType: this.newPromotion.promoType.trim(),
        brand: this.newPromotion.brand,
        model: this.newPromotion.model,
        capacity: this.newPromotion.capacity,
        color: this.newPromotion.color,
        discountTypeName: this.newPromotion.discountTypeName.trim(),
        executionType: this.newPromotion.executionType.trim(),
      }
      bodyToSave = {
        name: this.newPromotion.name.trim(),
        tenant: this.newPromotion.tenant.length ? this.newPromotion.tenant : [],
        channel: this.newPromotion.channel.length ? this.newPromotion.channel : [],
        description: this.newPromotion.description.trim(),
        legal_conditions: this.newPromotion.legal_conditions.trim(),
        type: this.promotionTypeId(this.newPromotion.promoType),
        units_limit: this.newPromotion.units_limit.toString(),
        start_date: this.newPromotion.start_date,
        end_date: this.newPromotion.end_date,
        start_actived_date: this.newPromotion.start_date,
        end_actived_date: this.newPromotion.end_date,
        priority: Number(this.newPromotion.priority),
        autoAssignment: this.newPromotion.autoAssignment,
        cumulative: this.newPromotion.cumulative,
        cumulativeCustumer: this.newPromotion.cumulativeCustumer,
        applyToRentServ: this.newPromotion.applyToRentServ,
        version: this.newPromotion.version.trim(),
        status: "PENDING",
        products: this.newPromotion.products,
        customers: this.newPromotion.customers,
      };
      bodyToSave.vouchers = {
          voucher_code: this.newPromotion.promoType === "VOUCHER" ? this.newPromotion.vouchers.voucher_code.toUpperCase() : '',
          use_limit: this.newPromotion.promoType === "VOUCHER" ? this.newPromotion.vouchers.use_limit : ''
      };
      bodyToSave.criteria = {
        name: this.newPromotion.criteria.name,
        condition: this.newPromotion.criteria.condition,
        parameters: this.newPromotion.criteria.parameters,
      };
      if (recoveryData.executionType == 'Todos') {
        bodyToSave.feeDiscounts = this.feesCalculator();
        recoveryData.fee1.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee2.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee3.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee4.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee5.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee6.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee7.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee8.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee9.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee10.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee11.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee12.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee13.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee14.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee15.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee16.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee17.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee18.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee19.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee20.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee21.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee22.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee23.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee24.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee25.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee26.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee27.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee28.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee29.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee30.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee31.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee32.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee33.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee34.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee35.value = this.newPromotion.feeTotalNumber.toString();
        recoveryData.fee36.value = this.newPromotion.feeTotalNumber.toString();
      } else if (recoveryData.executionType == 'Selección') {
        bodyToSave.feeDiscounts = [];
        bodyToSave.feeDiscounts.push(
          fee1, fee2, fee3, fee4, fee5, fee6, fee7, fee8, fee9, fee10, fee11, fee12, fee13, fee14, fee15, fee16, fee17, fee18, fee19, fee20, fee21, fee22, fee23, fee24, fee25, fee26, fee27, fee28, fee29, fee30, fee31, fee32, fee33, fee34, fee35, fee36  )
      }
      this.$store.commit('setNewPromotionData', bodyToSave);
      this.$store.commit('setNewRecoveryData', recoveryData);
      this.$router.push({ name: 'newPromotionStep2' });
    },
    discountTypeNameChange() {
      if (this.newPromotion.discountTypeName == 'Absoluto') {
        this.maxLength = 9;
        this.maxValue = 999999999;
        this.minValue = 0;
      } else if (this.newPromotion.discountTypeName == 'Porcentaje'){
        this.maxLength = 3;
        this.maxValue = 100;
        this.minValue = 0;
      }
    },
    feesCalculator() {
      let feeLoop = [];
      for (let i = 0; i < 36; i++) {
        let fee = {};
        fee.feeNumber = (i + 1).toString();
        fee.discountType = this.newPromotion.discountTypeName == "Absoluto" ? 'NUMBER' : "PERCENTAGE";
        fee.value = this.newPromotion.feeTotalNumber.toString();
        feeLoop.push(fee);
      }
      return feeLoop;
    },
    loadTenantData() {
      axios.get(`/tenants`).then((response) => {
        let arrayTenant = [];
        response.data.forEach((element) => {
          arrayTenant.push(element.nameNormalized);
        });
        this.tenantsData = arrayTenant;
        this.services.tenants = true;
      })
      .catch(() => {
        this.services.tenants = true;
      });
    },
    loadBrandsData() {
      axios.get(`/products/brands`)
        .then((response) => {
          this.brandsData = response.data;
        });
    },
    loadModelsData(idBrand) {
      axios.get(`/products/models-by-brand?brand=${idBrand}`)
        .then((response) => {
          this.modelsData = response.data;
        });
    },
    loadCapacitiesData(idBrand, idModel) {
      axios.get(`/products/capacities?brand=${idBrand}&model=${idModel}`)
        .then((response) => {
          this.capacitiesData = response.data;
        });
    },
    loadColorsData(idBrand, idModel, idCapacity) {
      axios.get(`/products/colors?brand=${idBrand}&model=${idModel}&capacity=${idCapacity}`)
        .then((response) => {
          this.colorsData = response.data;
        });
    },
    selectBrand(idBrand) {
      this.newPromotion.products = [];
      this.modelsData = [];
      this.capacitiesData = [];
      this.colorsData = [];
      this.newPromotion.capacity = '';
      this.newPromotion.color = '';
      this.newPromotion.model = '';
      if (idBrand != '') {
        this.loadModelsData(idBrand);
      }
    },
    selectModel(idModel) {
      this.newPromotion.products = [];
      this.capacitiesData = [];
      this.colorsData = [];
      this.newPromotion.capacity = '';
      this.newPromotion.color = '';
      if (idModel != '') {
        this.loadCapacitiesData(this.newPromotion.brand, idModel);
      }
    },
    selectCapacity(idCapacity) {
      this.newPromotion.products = [];
      this.colorsData = [];
      this.newPromotion.color = '';
      if (idCapacity != '') {
        this.loadColorsData(this.newPromotion.brand, this.newPromotion.model, idCapacity);
      }
    },
    selectColor(){
      this.newPromotion.products = [];
    },
    promotionTypeId(namePromotionType) {
      return this.typesDataId[this.typesDataName.indexOf(namePromotionType)];
    },
    promotionNameId(idPromotionType) {
      return this.typesDataName[this.typesDataId.indexOf(idPromotionType)];
    },
    loadPromoType(){
      axios.get(`/promotions/promotion-type/search?pagination.pageSize=100`)
        .then((response) => {
          this.promotionTypes = response.data.promotionType;
          for (let i = 0; i < this.promotionTypes.length; i++) {
            const promo = this.promotionTypes[i];
            this.typesDataName.push(promo.name);
            this.typesDataId.push(promo.id);
          }
          this.services.promotionType = true;
        })
        .catch(() => {
          this.services.promotionType = true;
        });
    },
    changeBarRange(e) {
      e.target.style.backgroundSize = (this.newPromotion.priority - 1) * 100 / (10 - 1) + '% 100%'
    },
    filter() {
      this.loadProducts();
    },
    filterBrand() {
      if (this.newPromotion.brand !== '' && this.newPromotion.brand !== undefined) {
        this.filters = `${this.filters}brand=${encodeURIComponent(this.newPromotion.brand)}&`;
      }
    },
    filterModel() {
      if (this.newPromotion.model !== '' && this.newPromotion.model !== undefined) {
        this.filters = `${this.filters}model=${encodeURIComponent(this.newPromotion.model)}&`;
      }
    },
    filterColor() {
      if (this.newPromotion.color !== '' && this.newPromotion.color !== undefined) {
        this.filters = `${this.filters}color=${this.newPromotion.color}&`;
      }
    },
    filterCapacity() {
      if (this.newPromotion.capacity !== '' && this.newPromotion.capacity !== undefined) {
        this.filters = `${this.filters}capacity=${this.newPromotion.capacity}&`;
      }
    },
    loadProducts() {
      this.loading = true;
      this.filters = '';
      this.filterBrand();
      this.filterModel();
      this.filterColor();
      this.filterCapacity();

      if (this.filters !== '') {
        this.filters = `?${this.filters}`;
      }

      axios.get(`/products/search${this.filters}`)
        .then((response) => {
          this.newPromotion.products = [];
          let selectedProducts = response.data.products;
          if(Array.isArray(selectedProducts) && selectedProducts.length > 0){
            for (let i = 0; i < selectedProducts.length; i++) {
              const element = selectedProducts[i].ean;
              this.newPromotion.products.push(element)
            }
          }
          this.loading = false;
        });
    },
    loadRules() {
      axios.get(`/promotions/rules`)
        .then((response) => {
          if (response.data && response.data.rules && Array.isArray(response.data.rules)) {
            response.data.rules.forEach((rule) => {
              rule.disabled = false;
              const firstKey = Object.keys(rule.parameters)[0];
              rule.parameters = firstKey;
            });
            this.formulas = response.data.rules;
            this.services.rules = true;
          }
        })
        .catch(() => {
            this.services.rules = true;
        });
    },
    addFormula(valor){
      this.showModalCriteria = false;
      this.formulas[this.indexFormula].disabled = true;
      this.resultados.push({
        name: this.formulaModal.name,
        condition: this.formulaModal.condition,
        parameters: this.formulaModal.parameters
      })
      this.operadores.push('&&');
      if(this.newPromotion.criteria.parameters) {
        this.newPromotion.criteria.parameters[this.formulaModal.parameters] =  valor
      } else {
        this.newPromotion.criteria.parameters = {};
        this.newPromotion.criteria.parameters[this.formulaModal.parameters] =  valor
      }
      this.$nextTick(() => {
        this.saveCondition();
      })
    },
    removeFormula(index, resultado){
      this.resultados.splice(index,1);
      this.operadores.splice(index,1);
      delete this.newPromotion.criteria.parameters[resultado.parameters];
      if (this.newPromotion.criteria.parameters && Object.keys(this.newPromotion.criteria.parameters).length === 0) {
        this.newPromotion.criteria.parameters = null;
      }
      for (let formula of this.formulas) {
        if (formula.name === resultado.name) {
          formula.disabled = false;
        }
      }
      this.$nextTick(() => {
        this.saveCondition();
      })
    },
    changeOperator(event, index){
      this.operadores[index] = event.target.value
      this.$nextTick(() => {
        this.saveCondition();
      })
    },
    saveCondition(){
      let lastIndex = this.resultados.length - 1;
      let resultConditionTemp = '';
      this.resultados.forEach((item, index) => {
        resultConditionTemp+=item.name;
        if (index !== lastIndex) {
          resultConditionTemp+=" "+this.operadores[index]+" ";
        }
      });
      this.newPromotion.criteria.condition = resultConditionTemp;
    },
    showModal(index, formula) {
      this.formulaModal = formula;
      this.indexFormula = index;
      this.showModalCriteria = true;
      this.$nextTick(() => {
        var myModal = new ModalBootstrap(document.getElementById('showModalCriteria'))
        myModal.show();
      })
		},
    loadPromotion(promotionId) {
      this.loadingPromotion = true;
      axios.get(`/promotions/promotion/search?promotionId=${promotionId}&pagination.pageSize=1&pagination.page=1`)
      .then((response) => {
        if(Array.isArray(response.data.promotions) && response.data.promotions.length > 0) {
          this.modalLoadPromotionMessage = 'Promoción Cargada Correctamente.';
          let promotion = response.data.promotions[0];
          let discountTypeNameTemp = promotion.feeDiscounts[0].discountType === 'NUMBER' ? 'Absoluto' : 'Porcentaje';
          let firstValue = promotion.feeDiscounts[0].value;
          let Todos = true;
          let executionTypeTemp = 'Todos';
          for (let i = 1; i < promotion.feeDiscounts.length; i++) {
            if (promotion.feeDiscounts[i].value !== firstValue) {
              Todos = false;
              break;
            }
          }
          if(!Todos) {
            executionTypeTemp = 'Selección';
          }
          let dataPromotion = {
            name: promotion.name,
            tenant: promotion.tenant,
            channel: promotion.channel,
            description: promotion.description,
            legal_conditions: promotion.legal_conditions,
            promoType: this.promotionNameId(promotion.type),
            units_limit: promotion.units_limit,
            start_date: this.$dateBackToFront(promotion.start_date),
            end_date: this.$dateBackToFront(promotion.end_date),
            priority: promotion.priority,
            autoAssignment: promotion.autoAssignment,
            cumulative: promotion.cumulative,
            cumulativeCustumer: promotion.cumulativeCustumer,
            version: "1",
            discountTypeName: discountTypeNameTemp,
            executionType: executionTypeTemp,
            feeTotalNumber: Todos ? firstValue : '',
            criteria: {
              name: '',
              condition: '',
              parameters: null
            },
            products: [],
            customers: promotion.customers,
            vouchers: {
              voucher_code: '',
              use_limit: '',
            },
            feeDiscounts: [],
          }
          if(promotion.vouchers !== null) {
            dataPromotion.vouchers.voucher_code = promotion.vouchers.voucher_code;
            dataPromotion.vouchers.use_limit = promotion.vouchers.use_limit;
          }
          for (let i = 0; i < 36; i++) {
            dataPromotion[`fee${i + 1}`] = {
                feeNumber: promotion.feeDiscounts[i]?.feeNumber || `${(i + 1).toString()}`,
                discountType: promotion.feeDiscounts[i]?.discountType || promotion.feeDiscounts[0]?.discountType,
                value: promotion.feeDiscounts[i]?.value || promotion.feeDiscounts[0]?.value
            };
          }

          this.resultados = [];
          this.operadores = [];
          this.formulaModal = null;
          this.indexFormula = null;

          this.formulas.forEach((element) => {
            element.disabled = false;
          });
          this.newPromotion = dataPromotion;
          this.$nextTick(() => {
            this.updateCriteria(promotion.criteria);
          })
          

        } else {
          this.modalLoadPromotionMessage = 'No se ha encontrado la promoción.';
        }
        
        this.loadingPromotion = false;
        this.showModalLoadPromotion = true;

        this.$nextTick(() => {
          var myModal = new ModalBootstrap(document.getElementById('showModalLoadPromotion'))
          myModal.show();
        })
      })
      .catch((error) => {
        this.loadingPromotion = false;
        this.modalLoadPromotionMessage = `Se ha producido un error, inténtelo más tarde: ${error?.response?.data?.message || "Error no definido."}`;
        this.showModalLoadPromotion = true;
        this.$nextTick(() => {
          var myModal = new ModalBootstrap(document.getElementById('showModalLoadPromotion'))
          myModal.show();
        })
      });
    },
    updateCriteria(criteria){
      if(criteria.parameters !== null){
        let cadena = criteria.condition;
        let resultados = [];
        let operadores = [];
        let conditionsTemp = '';

        while (cadena != '') {
          let indiceCierreFormula = cadena.indexOf(')') + 1;
          let name = cadena.substring(0, indiceCierreFormula);
          const objetoBuscado = this.formulas.find(objeto => objeto.name === name);
          if(objetoBuscado) {
            resultados.push({
              name: objetoBuscado.name,
              condition: objetoBuscado.condition,
              parameters: objetoBuscado.parameters
            })
            conditionsTemp = conditionsTemp + objetoBuscado.name;
            objetoBuscado.disabled = true;
            cadena = cadena.substring(indiceCierreFormula + 1);
            let indiceCierreOperator = cadena.indexOf(' ');
            let operador = cadena.substring(0, indiceCierreOperator);
            cadena = cadena.substring(indiceCierreOperator + 1);
            if(cadena != '') {
              operadores.push(operador);
              conditionsTemp = conditionsTemp + ' ' + operador + ' ';
            } else {
              operadores.push('&&');
            }
          } else {
            let indice1 = name.indexOf('(') + 1;
            let indice2 = name.indexOf(')');
            let parametro = name.substring(indice1,indice2);
            delete criteria.parameters[parametro];
            cadena = cadena.substring(indiceCierreFormula + 4);
          }
        }
        if(resultados.length > 0){
          this.newPromotion.criteria = {
            name: criteria.name,
            condition: conditionsTemp,
            parameters: criteria.parameters
          }
          this.resultados = resultados;
          this.operadores = operadores;
          this.saveCondition();
        }
      }
    },
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../../../scss/variables.scss';

.typeNumber::-webkit-inner-spin-button {
  appearance: none;
  margin: 0;
}

.typeNumber {
  appearance: textfield;
}

input,
output {
  display: inline-block;
  vertical-align: middle;
  font-size: 1em;
  font-family: Arial, sans-serif;
}

output {
  padding: 5px;
  border-radius: 3px;
  color: $primary;
  width: 35px;
  text-align: center;
  border: 2px solid $primary;
  font-weight: bold;
}

input[type="range"] {
  -webkit-appearance: none;
  margin-right: 5%;
  width: 76%;
  height: 10px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 5px;
  background-image: linear-gradient($primary, $primary);
  background-size: 0% 100%;
  background-repeat: no-repeat;
  border: 1px solid #e5e4e4;
}

/* Input Thumb */
input[type="range"]::-webkit-slider-thumb {
  -webkit-appearance: none;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: $primary;
  cursor: ew-resize;
  box-shadow: 0 0 2px 0 #555;
  transition: background .3s ease-in-out;
}

input[type="range"]::-moz-range-thumb {
  -webkit-appearance: none;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: $primary;
  cursor: ew-resize;
  box-shadow: 0 0 2px 0 #555;
  transition: background .3s ease-in-out;
}

input[type="range"]::-ms-thumb {
  -webkit-appearance: none;
  height: 20px;
  width: 20px;
  border-radius: 50%;
  background: $primary;
  cursor: ew-resize;
  box-shadow: 0 0 2px 0 #555;
  transition: background .3s ease-in-out;
}

input[type="range"]::-webkit-slider-thumb:hover {
  background: $primary-hover;
}

input[type="range"]::-moz-range-thumb:hover {
  background: $primary-hover;
}

input[type="range"]::-ms-thumb:hover {
  background: $primary-hover;
}

/* Input Track */
input[type=range]::-webkit-slider-runnable-track {
  -webkit-appearance: none;
  box-shadow: none;
  border: none;
  background: transparent;
}

input[type=range]::-moz-range-track {
  -webkit-appearance: none;
  box-shadow: none;
  border: none;
  background: transparent;
}

input[type="range"]::-ms-track {
  -webkit-appearance: none;
  box-shadow: none;
  border: none;
  background: transparent;
}

#promotionForm .vue-select.direction-bottom.form-control.generalInput[aria-expanded="true"] {
  z-index: 2;
}
.criterios {
  border: 1px solid #e5e4e4;
  padding: 20px;
  &-content {
    display: flex;
    flex-wrap: wrap;
    border: 1px solid #e5e4e4;
    min-height: 100px;
    padding: 10px;
    gap: 5px;
    background-color: white;
  }
  .generalSecondaryButton {
    background-color: #ffefff;
    padding: 6px;
    display: flex; 
    height: 40px;
    align-items: center;
    border-radius: 4px;
    text-transform: none;

  }
  .generalSecondaryButton:hover {
    background-color: #e5e4e4;
  }
  select {
    display: flex;
    width: 70px;
    height: 40px;
  }
}
.searchPromotion {
  display: flex; 
  gap: 7px; 
  flex-wrap: wrap; 
  align-items: center; 
  border-bottom: 1px solid #e5e4e4;
  padding-bottom: 10px;
  label {
    margin-bottom: 0;
  }
  input {
    max-width: 20ch;
  }
  button {
    margin: 0;
  }
}
</style>